// import React, { useState, useEffect } from "react";
// import { UserCircle } from "lucide-react";
// import { useSelector } from "react-redux";
// import useApi from "../CustomHooks/useApi";

// const Profile = () => {

//   const merchantdetails = useSelector((state) => state.auth?.employeeDetails);
//   const [mpinData, setMpinData] = useState({
//     mobileNumber: '',
//     otp: '',
//     newMpin: '',
//     confirmMpin: ''
//   });
//   const [otpSent, setOtpSent] = useState(false);
//   const [otpVerified, setOtpVerified] = useState(false);
//   const [message, setMessage] = useState({ type: '', text: '' });

//   const [transferAmount, setTransferAmount] = useState('');
//   const [transferMessage, setTransferMessage] = useState({ type: '', text: '' });
//   const [isloading, setIsLoading] = useState(false);

//   const [transferAepsAmount, setTransferAepsAmount] = useState('');
//   const [transferAepsMessage, setTransferAepsMessage] = useState({ type: '', text: '' });
//   const [isloadingAeps, setIsLoadingAeps] = useState(false);
//   const [showPopup, setShowPopup] = useState(false);
//   const [popupData, setPopupData] = useState({ type: "", text: "" });

//   const { callApi: callsendotp } = useApi(
//     "/staff/onboard/send/indus/otp",
//     "POST", false
//   );

//   const [passwordData, setPasswordData] = useState({
//     newPassword: "",
//     confirmPassword: ""
//   });

//   const [passwordOtpSent, setPasswordOtpSent] = useState(false);

//   const handleSendPasswordOtp = async () => {
//     try {
//       const res = await callsendotp(
//         null,
//         `?mobileNumber=${merchantdetails?.mobile_number}`
//       );

//       if (res?.error_code && res?.error === "OK") {
//         setPopupData({ type: "error", text: res.message });
//         setShowPopup(true);
//         return;
//       }

//       if (res?.otp_status === "VERIFIED" || res?.otp_status === "success") {
//         setPasswordOtpSent(true);
//         setPopupData({ type: "success", text: "OTP sent successfully" });
//         setShowPopup(true);
//         return;
//       }

//       if (res?.error === "Accepted") {
//         setPopupData({ type: "info", text: res.message });
//         setShowPopup(true);
//         return;
//       }

//       setPopupData({ type: "error", text: "Failed to send OTP" });
//       setShowPopup(true);

//     } catch (err) {
//       setPopupData({
//         type: "error",
//         text: "Server error while sending OTP"
//       });
//       setShowPopup(true);
//     }
//   };

//   const handleResetPassword = async () => {
//     const { otp, newPassword, confirmPassword } = passwordData;

//     if (!otp || otp.length !== 6) {
//       setPopupData({ type: "error", text: "Enter valid OTP" });
//       setShowPopup(true);
//       return;
//     }

//     if (!newPassword || !confirmPassword) {
//       setPopupData({ type: "error", text: "Enter password fields" });
//       setShowPopup(true);
//       return;
//     }

//     if (newPassword !== confirmPassword) {
//       setPopupData({ type: "error", text: "Passwords do not match" });
//       setShowPopup(true);
//       return;
//     }

//     try {
//       const body = {
//         mobile_number: merchantdetails?.mobile_number,
//         otp: otp,
//         password: newPassword,
//         confirm_password: confirmPassword
//       };

//       const response = await resetMpinApi(body);

//       if (response?.status === "SUCCESS" || response?.status === "VERIFIED") {
//         setPopupData({
//           type: "success",
//           text: response.message || "Password updated successfully"
//         });
//         setShowPopup(true);

//         // reset state
//         setPasswordData({
//           otp: "",
//           newPassword: "",
//           confirmPassword: ""
//         });
//         setPasswordOtpSent(false);

//       } else {
//         setPopupData({
//           type: "error",
//           text: response.message || "Failed to reset password"
//         });
//         setShowPopup(true);
//       }

//     } catch (error) {
//       setPopupData({
//         type: "error",
//         text: "Server error while resetting password"
//       });
//       setShowPopup(true);
//     }
//   };

//   const { callApi: verifyOtpApi } = useApi("/staff/onboard/verify/indus/otp", "POST", false);
//   const { callApi: resetMpinApi } = useApi("/staff/onboard/forget/password", "POST", false);
//   const { callApi: transferCommissionApi } = useApi("/business/wallet/settle", "POST");
//   const { callApi: transferaepstomainwallet } = useApi("/business/wallet/aeps/settle", "POST");


//   useEffect(() => {
//     if (merchantdetails?.mobile_number) {
//       setMpinData(prev => ({ ...prev, mobileNumber: merchantdetails.mobile_number }));
//     }
//   }, [merchantdetails]);

//   const handleMpinChange = (field, value) => {
//     setMpinData(prev => ({
//       ...prev,
//       [field]: value
//     }));
//   };

//   const handleSendOtp = async () => {
//     try {
//       const response = await callsendotp(null, `?mobileNumber=${merchantdetails.mobile_number}`);
//       if (response.otp_status === "VERIFIED" || response.otp_status === "success") {
//         setOtpSent(true);
//         setMessage({ type: 'success', text: 'OTP sent successfully.' });
//       } else {
//         setMessage({ type: 'error', text: 'Failed to send OTP. Try again.' });
//       }
//     } catch (error) {
//       setMessage({ type: 'error', text: 'Error sending OTP.' });
//     }
//   };

//   const handleVerifyOtp = async () => {
//     const { mobileNumber, otp } = mpinData;

//     if (!otp || otp.length !== 6) {
//       setMessage({ type: 'error', text: 'Please enter a valid 6-digit OTP.' });
//       return;
//     }
//     if (!mobileNumber) {
//       setMessage({ type: 'error', text: 'Mobile number is required.' });
//       return;
//     }

//     // try {
//     //   const response = await verifyOtpApi(null, `?mobileNumber=${mobileNumber}&otp=${otp}`);
//     //   if (response.otp_status === "VERIFIED" || response.otp_status === "success") {
//     //     setOtpVerified(true);
//     //     setMessage({ type: 'success', text: 'OTP verified successfully.' });
//     //   } else {
//     //     setMessage({ type: 'error', text: 'Invalid OTP. Please try again.' });
//     //   }
//     // }
//     // catch (error) {
//     //   setMessage({ type: 'error', text: 'Error verifying OTP. Please try again.' });
//     // }
//     try {
//       const response = await verifyOtpApi(
//         null,
//         `?mobileNumber=${mobileNumber}&otp=${otp}`
//       );

//       if (response?.otp_status === "VERIFIED") {
//         setOtpVerified(true);

//         setPopupData({
//           type: "success",
//           text: "OTP verified successfully."
//         });
//         setShowPopup(true);

//       } else if (response?.otp_status === "FAILED") {
//         setOtpVerified(false);

//         setPopupData({
//           type: "error",
//           text: "Invalid OTP. Please try again."
//         });
//         setShowPopup(true);

//       } else {
//         setOtpVerified(false);

//         setPopupData({
//           type: "error",
//           text: "OTP verification failed. Please try again."
//         });
//         setShowPopup(true);
//       }

//     } catch (error) {
//       setOtpVerified(false);

//       setPopupData({
//         type: "error",
//         text: "Error verifying OTP. Please try again."
//       });
//       setShowPopup(true);
//     }

//   };

//   const handleSetMpin = async () => {
//     if (mpinData.newMpin !== mpinData.confirmMpin) {
//       setMessage({ type: 'error', text: 'MPIN and Confirm MPIN do not match!' });
//       return;
//     }
//     if (mpinData.newMpin.length !== 6) {
//       setMessage({ type: 'error', text: 'MPIN must be 6 digits!' });
//       return;
//     }

//     const requestBody = {
//       otp: mpinData.otp,
//       confirm_mpin: mpinData.confirmMpin,
//       mobile_number: mpinData.mobileNumber,
//       mpin: mpinData.newMpin
//     };

//     try {
//       const response = await resetMpinApi(requestBody);
//       // if (response.status === "VERIFIED") {
//       //   setMessage({ type: 'success', text: response.message });
//       //   setMpinData({
//       //     mobileNumber: '',
//       //     otp: '',
//       //     newMpin: '',
//       //     confirmMpin: ''
//       //   });
//       //   setOtpSent(false);
//       //   setOtpVerified(false);
//       // } else {
//       //   setMessage({ type: 'error', text: response.message });
//       // }
//       if (response.status === "VERIFIED") {
//         setPopupData({
//           type: "success",
//           text: response.message || "MPIN updated successfully"
//         });
//         setShowPopup(true);

//         setMpinData({
//           mobileNumber: merchantdetails?.mobile_number || '',
//           otp: '',
//           newMpin: '',
//           confirmMpin: ''
//         });
//         setOtpSent(false);
//         setOtpVerified(false);
//       } else {
//         setPopupData({
//           type: "error",
//           text: response.message || "Failed to update MPIN"
//         });
//         setShowPopup(true);
//       }
//     }
//     // catch (error) {
//     //   console.error(error);
//     // }
//     catch (error) {
//       setPopupData({
//         type: "error",
//         text: "Something went wrong while updating MPIN"
//       });
//       setShowPopup(true);
//     }
//   };

//   // Transfer Commission Handler
//   const handleTransferCommission = async () => {
//     if (!transferAmount || transferAmount <= 0 || transferAmount >= 999999) {
//       setTransferMessage({ type: 'error', text: 'Please enter a valid amount.' });
//       setIsLoading(false);
//       return;
//     }
//     setIsLoading(true);

//     try {
//       const response = await transferCommissionApi(null, `?amount=${parseFloat(transferAmount)}&userId=${merchantdetails?.userId}`);
//       if (response.status === "SUCCESS") {
//         setTransferMessage({ type: 'success', text: `Money transferred successfully :- Main Wallet Balance ${response.mainWallet.balance} and Commission Wallet Balance ${response.commissionWallet.balance}` });
//         setTransferAmount('');
//       } else if (response.error_code === 202) {
//         setTransferMessage({ type: 'error', text: response.message });
//       } else {
//         setTransferMessage({ type: 'error', text: response.message || 'Failed to transfer commission.' });
//       }
//     } catch (error) {
//       setTransferMessage({ type: 'error', text: 'Error transferring commission. Please try again.' });
//       console.error(error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleTransferAespstomain = async () => {
//     if (!transferAepsAmount || transferAepsAmount <= 0 || transferAepsAmount >= 999999) {
//       setTransferAepsMessage({ type: 'error', text: 'Please enter a valid amount.' });
//       setIsLoadingAeps(false);
//       return;
//     }
//     setIsLoadingAeps(true);

//     try {
//       const response = await transferaepstomainwallet(null, `?amount=${parseFloat(transferAepsAmount)}&userId=${merchantdetails?.userId}`);
//       if (response.status === "SUCCESS") {
//         setTransferAepsMessage({ type: 'success', text: `Money transferred successfully :- Main Wallet Balance ${response.mainWallet.balance} and AEPS Wallet Balance ${response.commissionWallet.balance}` });
//         setTransferAepsAmount('');
//       } else if (response.error_code === 202) {
//         setTransferAepsMessage({ type: 'error', text: response.message });
//       } else {
//         setTransferAepsMessage({ type: 'error', text: response.message || 'Failed to transfer commission.' });
//       }
//     } catch (error) {
//       setTransferAepsMessage({ type: 'error', text: 'Error transferring commission. Please try again.' });
//       console.error(error);
//     } finally {
//       setIsLoadingAeps(false);
//     }
//   };

//   return (
//     <div className="min-h-screen bg-[#eef1f6] px-4 py-5">
//       <div className="max-w-7xl mx-auto space-y-8">

//         {/* ===== PROFILE CONTENT ===== */}
//         {/* <div className="grid grid-cols-1 lg:grid-cols-3 gap-5"> */}
//         <div className="space-y-5">

//           <div
//             className="
    
//     rounded-3xl p-5
//     bg-[#eef1f6]
//     shadow-[10px_10px_20px_#d1d5db,-10px_-10px_20px_#ffffff]
//   "
//           >
//             <div
//               className="
//       flex items-center gap-4
//       px-4 py-3 mb-4
//       rounded-2xl

//       bg-[#eef1f6]
//       shadow-[6px_6px_12px_#d1d5db,-6px_-6px_12px_#ffffff]
//     "
//             >
//               {/* AVATAR */}
//               <div
//                 className="
//         w-12 h-12 rounded-xl
//         flex items-center justify-center
//         bg-[#eef1f6]
//         shadow-[inset_3px_3px_6px_#d1d5db,inset_-3px_-3px_6px_#ffffff]
//         text-indigo-600
//         shrink-0
//       "
//               >
//                 <UserCircle size={26} />
//               </div>

//               {/* NAME + ROLE */}
//               <div className="leading-tight">
//                 <h1 className="text-base font-semibold text-slate-800">
//                   {merchantdetails?.others?.merchant_shop_name || "Profile"}
//                 </h1>
//                 <p className="text-[10px] uppercase tracking-widest text-slate-500 mt-0.5">
//                   {merchantdetails?.role || "—"}
//                 </p>
//               </div>
//             </div>

//             {/* ===== SECTION TITLE ===== */}
//             <h2 className="text-xs font-semibold text-slate-600 uppercase mb-3">
//               Personal Information
//             </h2>

//             {/* ===== INFO GRID ===== */}
//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
//               {[
//                 { label: "User ID", value: merchantdetails?.userId },
//                 { label: "Shopname", value: merchantdetails?.others?.merchant_shop_name },
//                 { label: "Role", value: merchantdetails?.role },
//                 { label: "Merchant Account No", value: merchantdetails?.merchant_account_no },
//                 { label: "Mobile Number", value: merchantdetails?.mobile_number },
//                 {
//                   label: "Distributor Name",
//                   value: merchantdetails?.others?.distributor_name,
//                 },
//                 {
//                   label: "Distributor Mobile",
//                   value: merchantdetails?.others?.distributor_mobile,
//                 },
//               ].map((item, idx) => (
//                 <div
//                   key={idx}
//                   className="
//           px-3 py-2.5 rounded-xl
//           bg-[#eef1f6]
//           shadow-[inset_4px_4px_8px_#d1d5db,inset_-4px_-4px_8px_#ffffff]
//         "
//                 >
//                   <p className="text-[10px] uppercase tracking-wide text-slate-500">
//                     {item.label}
//                   </p>
//                   <p className="mt-0.5 text-sm font-medium text-slate-800">
//                     {item.value || "N.A"}
//                   </p>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* SECURITY + WALLETS */}
//           <div
//             className="
//             rounded-3xl p-5
//             bg-[#eef1f6]
//             shadow-[10px_10px_20px_#d1d5db,-10px_-10px_20px_#ffffff]
//           "
//           >
//             <h2 className="text-sm font-semibold text-slate-700 mb-3">
//               MPIN & Wallet Security
//             </h2>

//             <div className="space-y-4">

//               {/* MPIN */}
//               <div className="space-y-3">
//                 <p className="text-xs font-semibold text-slate-600 uppercase">
//                   Change MPIN
//                 </p>

//                 <button
//                   onClick={handleSendOtp}
//                   disabled={otpSent}
//                   className="
//                   w-full py-2 rounded-xl text-sm font-semibold
//                   bg-[#eef1f6]
//                   shadow-[6px_6px_12px_#d1d5db,-6px_-6px_12px_#ffffff]
//                   text-indigo-600
//                   active:shadow-[inset_6px_6px_12px_#d1d5db,inset_-6px_-6px_12px_#ffffff]
//                   disabled:opacity-60
//                 "
//                 >
//                   {otpSent ? "OTP Sent" : "Send OTP"}
//                 </button>

//                 {otpSent && !otpVerified && (
//                   <>
//                     <input
//                       value={mpinData.otp}
//                       onChange={(e) =>
//                         handleMpinChange("otp", e.target.value.replace(/\D/g, ""))
//                       }
//                       maxLength={6}
//                       placeholder="Enter OTP"
//                       className="
//                       w-full px-3 py-2.5 rounded-xl text-sm
//                       bg-[#eef1f6]
//                       shadow-[inset_4px_4px_8px_#d1d5db,inset_-4px_-4px_8px_#ffffff]
//                     "
//                     />

//                     <button
//                       onClick={handleVerifyOtp}
//                       className="
//                       w-full py-2.5 rounded-xl text-sm font-semibold
//                       bg-slate-800 text-white
//                     "
//                     >
//                       Verify OTP
//                     </button>
//                   </>
//                 )}

//                 {otpVerified && (
//                   <>
//                     <input
//                       type="password"
//                       value={mpinData.newMpin}
//                       onChange={(e) =>
//                         handleMpinChange("newMpin", e.target.value.replace(/\D/g, ""))
//                       }
//                       maxLength={6}
//                       placeholder="New MPIN"
//                       className="w-full px-3 py-2.5 rounded-xl bg-[#eef1f6]
//                     shadow-[inset_4px_4px_8px_#d1d5db,inset_-4px_-4px_8px_#ffffff]"
//                     />
//                     <input
//                       type="password"
//                       value={mpinData.confirmMpin}
//                       onChange={(e) =>
//                         handleMpinChange("confirmMpin", e.target.value.replace(/\D/g, ""))
//                       }
//                       maxLength={6}
//                       placeholder="Confirm MPIN"
//                       className="w-full px-3 py-2.5 rounded-xl bg-[#eef1f6]
//                     shadow-[inset_4px_4px_8px_#d1d5db,inset_-4px_-4px_8px_#ffffff]"
//                     />
//                     <button
//                       onClick={handleSetMpin}
//                       className="
//                       w-full py-2.5 rounded-xl text-sm font-semibold
//                       bg-indigo-600 text-white
//                     "
//                     >
//                       Set MPIN
//                     </button>
//                   </>
//                 )}
//               </div>

//               {/* COMMISSION */}
//               {/* <div className="pt-3 border-t border-slate-300/40 space-y-2.5">
//                 <p className="text-xs font-semibold text-slate-600 uppercase">
//                   Commission → Main Wallet
//                 </p>

//                 <input
//                   value={transferAmount}
//                   onChange={(e) => setTransferAmount(e.target.value)}
//                   placeholder="Amount"
//                   className="w-full px-3 py-2.5 rounded-xl bg-[#eef1f6]
//                 shadow-[inset_4px_4px_8px_#d1d5db,inset_-4px_-4px_8px_#ffffff]"
//                 />

//                 <button
//                   onClick={handleTransferCommission}
//                   disabled={isloading}
//                   className="
//                   w-full py-2.5 rounded-xl text-sm font-semibold
//                   bg-[#eef1f6]
//                   shadow-[6px_6px_12px_#d1d5db,-6px_-6px_12px_#ffffff]
//                   text-indigo-600
//                   disabled:opacity-60
//                 "
//                 >
//                   Transfer
//                 </button>
//               </div> */}

//               {/* AEPS */}
//               {/* <div className="pt-3 border-t border-slate-300/40 space-y-3">
//                 <p className="text-xs font-semibold text-slate-600 uppercase">
//                   AEPS → Main Wallet
//                 </p>

//                 <input
//                   value={transferAepsAmount}
//                   onChange={(e) => setTransferAepsAmount(e.target.value)}
//                   placeholder="Amount"
//                   className="w-full px-3 py-2.5 rounded-xl bg-[#eef1f6]
//                 shadow-[inset_4px_4px_8px_#d1d5db,inset_-4px_-4px_8px_#ffffff]"
//                 />

//                 <button
//                   onClick={handleTransferAespstomain}
//                   disabled={isloadingAeps}
//                   className="
//                   w-full py-2.5 rounded-xl text-sm font-semibold
//                   bg-[#eef1f6]
//                   shadow-[6px_6px_12px_#d1d5db,-6px_-6px_12px_#ffffff]
//                   text-indigo-600
//                   disabled:opacity-60
//                 "
//                 >
//                   Transfer
//                 </button>
//               </div> */}

//             </div>

//             <div className="pt-4 border-t border-slate-300/40 space-y-3">
//               <p className="text-xs font-semibold text-slate-600 uppercase">
//                 Reset Password
//               </p>

//               {!passwordOtpSent ? (
//                 <button
//                   onClick={handleSendPasswordOtp}
//                   disabled={otpSent}
//                   className="
//                   w-full py-2 rounded-xl text-sm font-semibold
//                   bg-[#eef1f6]
//                   shadow-[6px_6px_12px_#d1d5db,-6px_-6px_12px_#ffffff]
//                   text-indigo-600
//                   active:shadow-[inset_6px_6px_12px_#d1d5db,inset_-6px_-6px_12px_#ffffff]
//                   disabled:opacity-60
//                 "
//                 >
//                   Send OTP
//                 </button>
//               ) : (
//                 <>
//                   <input
//                     value={passwordData.otp}
//                     onChange={(e) =>
//                       setPasswordData(prev => ({
//                         ...prev,
//                         otp: e.target.value.replace(/\D/g, "")
//                       }))
//                     }
//                     maxLength={6}
//                     placeholder="Enter OTP"
//                     className="w-full px-3 py-2.5 rounded-xl bg-[#eef1f6]
//         shadow-[inset_4px_4px_8px_#d1d5db,inset_-4px_-4px_8px_#ffffff]"
//                   />

//                   <input
//                     type="password"
//                     value={passwordData.newPassword}
//                     onChange={(e) =>
//                       setPasswordData(prev => ({
//                         ...prev,
//                         newPassword: e.target.value
//                       }))
//                     }
//                     placeholder="New Password"
//                     className="w-full px-3 py-2.5 rounded-xl bg-[#eef1f6]"
//                   />

//                   <input
//                     type="password"
//                     value={passwordData.confirmPassword}
//                     onChange={(e) =>
//                       setPasswordData(prev => ({
//                         ...prev,
//                         confirmPassword: e.target.value
//                       }))
//                     }
//                     placeholder="Confirm Password"
//                     className="w-full px-3 py-2.5 rounded-xl bg-[#eef1f6]"
//                   />

//                   <button
//                     onClick={handleResetPassword}
//                     className="w-full py-2.5 rounded-xl text-sm font-semibold
//         bg-indigo-600 text-white"
//                   >
//                     Reset Password
//                   </button>
//                 </>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//       {showPopup && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
//           <div className="bg-white rounded-2xl shadow-xl w-[90%] max-w-sm p-5">
//             <div className="flex items-center gap-3">
//               {popupData.type === "success" ? (
//                 <div className="w-10 h-10 flex items-center justify-center rounded-full bg-green-100 text-green-600">
//                   ✓
//                 </div>
//               ) : (
//                 <div className="w-10 h-10 flex items-center justify-center rounded-full bg-red-100 text-red-600">
//                   !
//                 </div>
//               )}
//               <h3 className="text-lg font-semibold text-slate-800">
//                 {popupData.type === "success" ? "Success" : "Error"}
//               </h3>
//             </div>

//             <p className="mt-3 text-sm text-slate-600">
//               {popupData.text}
//             </p>

//             <button
//               onClick={() => setShowPopup(false)}
//               className="mt-5 w-full py-2.5 rounded-xl font-semibold text-white
//         bg-indigo-600 hover:bg-indigo-700"
//             >
//               OK
//             </button>
//           </div>
//         </div>
//       )}

//     </div>
//   );


// };

// export default Profile;


// import React, { useState, useEffect } from "react";
// import { 
//   UserCircle2, 
//   ShieldCheck, 
//   KeyRound, 
//   Lock, 
//   Smartphone, 
//   Store, 
//   User, 
//   Hash, 
//   CheckCircle2, 
//   AlertCircle, 
//   Send, 
//   Key,
//   CreditCard,
//   PhoneCall,
//   UserCheck
// } from "lucide-react";
// import { useSelector } from "react-redux";
// import useApi from "../CustomHooks/useApi";

// const Profile = () => {
//   const merchantdetails = useSelector((state) => state.auth?.employeeDetails);
  
//   const [mpinData, setMpinData] = useState({
//     mobileNumber: '',
//     otp: '',
//     newMpin: '',
//     confirmMpin: ''
//   });
//   const [otpSent, setOtpSent] = useState(false);
//   const [otpVerified, setOtpVerified] = useState(false);
//   const [message, setMessage] = useState({ type: '', text: '' });

//   const [transferAmount, setTransferAmount] = useState('');
//   const [transferMessage, setTransferMessage] = useState({ type: '', text: '' });
//   const [isloading, setIsLoading] = useState(false);

//   const [transferAepsAmount, setTransferAepsAmount] = useState('');
//   const [transferAepsMessage, setTransferAepsMessage] = useState({ type: '', text: '' });
//   const [isloadingAeps, setIsLoadingAeps] = useState(false);
  
//   const [showPopup, setShowPopup] = useState(false);
//   const [popupData, setPopupData] = useState({ type: "", text: "" });

//   const { callApi: callsendotp } = useApi(
//     "/staff/onboard/send/indus/otp",
//     "POST", 
//     false
//   );

//   const [passwordData, setPasswordData] = useState({
//     otp: "",
//     newPassword: "",
//     confirmPassword: ""
//   });

//   const [passwordOtpSent, setPasswordOtpSent] = useState(false);

//   const { callApi: verifyOtpApi } = useApi("/staff/onboard/verify/indus/otp", "POST", false);
//   const { callApi: resetMpinApi } = useApi("/staff/onboard/forget/password", "POST", false);
//   const { callApi: transferCommissionApi } = useApi("/business/wallet/settle", "POST");
//   const { callApi: transferaepstomainwallet } = useApi("/business/wallet/aeps/settle", "POST");

//   useEffect(() => {
//     if (merchantdetails?.mobile_number) {
//       setMpinData(prev => ({ ...prev, mobileNumber: merchantdetails.mobile_number }));
//     }
//   }, [merchantdetails]);

//   const handleSendPasswordOtp = async () => {
//     try {
//       const res = await callsendotp(
//         null,
//         `?mobileNumber=${merchantdetails?.mobile_number}`
//       );

//       if (res?.error_code && res?.error === "OK") {
//         setPopupData({ type: "error", text: res.message });
//         setShowPopup(true);
//         return;
//       }

//       if (res?.otp_status === "VERIFIED" || res?.otp_status === "success") {
//         setPasswordOtpSent(true);
//         setPopupData({ type: "success", text: "OTP sent successfully" });
//         setShowPopup(true);
//         return;
//       }

//       if (res?.error === "Accepted") {
//         setPopupData({ type: "info", text: res.message });
//         setShowPopup(true);
//         return;
//       }

//       setPopupData({ type: "error", text: "Failed to send OTP" });
//       setShowPopup(true);

//     } catch (err) {
//       setPopupData({
//         type: "error",
//         text: "Server error while sending OTP"
//       });
//       setShowPopup(true);
//     }
//   };

//   const handleResetPassword = async () => {
//     const { otp, newPassword, confirmPassword } = passwordData;

//     if (!otp || otp.length !== 6) {
//       setPopupData({ type: "error", text: "Enter valid 6-digit OTP" });
//       setShowPopup(true);
//       return;
//     }

//     if (!newPassword || !confirmPassword) {
//       setPopupData({ type: "error", text: "Please fill both password fields" });
//       setShowPopup(true);
//       return;
//     }

//     if (newPassword !== confirmPassword) {
//       setPopupData({ type: "error", text: "Passwords do not match" });
//       setShowPopup(true);
//       return;
//     }

//     try {
//       const body = {
//         mobile_number: merchantdetails?.mobile_number,
//         otp: otp,
//         password: newPassword,
//         confirm_password: confirmPassword
//       };

//       const response = await resetMpinApi(body);

//       if (response?.status === "SUCCESS" || response?.status === "VERIFIED") {
//         setPopupData({
//           type: "success",
//           text: response.message || "Password updated successfully"
//         });
//         setShowPopup(true);

//         setPasswordData({
//           otp: "",
//           newPassword: "",
//           confirmPassword: ""
//         });
//         setPasswordOtpSent(false);
//       } else {
//         setPopupData({
//           type: "error",
//           text: response.message || "Failed to reset password"
//         });
//         setShowPopup(true);
//       }
//     } catch (error) {
//       setPopupData({
//         type: "error",
//         text: "Server error while resetting password"
//       });
//       setShowPopup(true);
//     }
//   };

//   const handleMpinChange = (field, value) => {
//     setMpinData(prev => ({
//       ...prev,
//       [field]: value
//     }));
//   };

//   const handleSendOtp = async () => {
//     try {
//       const response = await callsendotp(null, `?mobileNumber=${merchantdetails?.mobile_number}`);
//       if (response?.otp_status === "VERIFIED" || response?.otp_status === "success") {
//         setOtpSent(true);
//         setMessage({ type: 'success', text: 'OTP sent successfully.' });
//       } else {
//         setMessage({ type: 'error', text: 'Failed to send OTP. Try again.' });
//       }
//     } catch (error) {
//       setMessage({ type: 'error', text: 'Error sending OTP.' });
//     }
//   };

//   const handleVerifyOtp = async () => {
//     const { mobileNumber, otp } = mpinData;

//     if (!otp || otp.length !== 6) {
//       setMessage({ type: 'error', text: 'Please enter a valid 6-digit OTP.' });
//       return;
//     }
//     if (!mobileNumber) {
//       setMessage({ type: 'error', text: 'Mobile number is required.' });
//       return;
//     }

//     try {
//       const response = await verifyOtpApi(
//         null,
//         `?mobileNumber=${mobileNumber}&otp=${otp}`
//       );

//       if (response?.otp_status === "VERIFIED") {
//         setOtpVerified(true);
//         setPopupData({
//           type: "success",
//           text: "OTP verified successfully."
//         });
//         setShowPopup(true);
//       } else if (response?.otp_status === "FAILED") {
//         setOtpVerified(false);
//         setPopupData({
//           type: "error",
//           text: "Invalid OTP. Please try again."
//         });
//         setShowPopup(true);
//       } else {
//         setOtpVerified(false);
//         setPopupData({
//           type: "error",
//           text: "OTP verification failed. Please try again."
//         });
//         setShowPopup(true);
//       }
//     } catch (error) {
//       setOtpVerified(false);
//       setPopupData({
//         type: "error",
//         text: "Error verifying OTP. Please try again."
//       });
//       setShowPopup(true);
//     }
//   };

//   const handleSetMpin = async () => {
//     if (mpinData.newMpin !== mpinData.confirmMpin) {
//       setMessage({ type: 'error', text: 'MPIN and Confirm MPIN do not match!' });
//       return;
//     }
//     if (mpinData.newMpin.length !== 6) {
//       setMessage({ type: 'error', text: 'MPIN must be 6 digits!' });
//       return;
//     }

//     const requestBody = {
//       otp: mpinData.otp,
//       confirm_mpin: mpinData.confirmMpin,
//       mobile_number: mpinData.mobileNumber,
//       mpin: mpinData.newMpin
//     };

//     try {
//       const response = await resetMpinApi(requestBody);
//       if (response?.status === "VERIFIED") {
//         setPopupData({
//           type: "success",
//           text: response.message || "MPIN updated successfully"
//         });
//         setShowPopup(true);

//         setMpinData({
//           mobileNumber: merchantdetails?.mobile_number || '',
//           otp: '',
//           newMpin: '',
//           confirmMpin: ''
//         });
//         setOtpSent(false);
//         setOtpVerified(false);
//       } else {
//         setPopupData({
//           type: "error",
//           text: response.message || "Failed to update MPIN"
//         });
//         setShowPopup(true);
//       }
//     } catch (error) {
//       setPopupData({
//         type: "error",
//         text: "Something went wrong while updating MPIN"
//       });
//       setShowPopup(true);
//     }
//   };

//   const infoList = [
//     { label: "User ID", value: merchantdetails?.userId, icon: <Hash className="w-4 h-4 text-blue-600" /> },
//     { label: "Shop Name", value: merchantdetails?.others?.merchant_shop_name, icon: <Store className="w-4 h-4 text-indigo-600" /> },
//     { label: "Account Role", value: merchantdetails?.role, icon: <User className="w-4 h-4 text-sky-600" /> },
//     { label: "Merchant Account No", value: merchantdetails?.merchant_account_no, icon: <CreditCard className="w-4 h-4 text-emerald-600" /> },
//     { label: "Registered Mobile", value: merchantdetails?.mobile_number, icon: <Smartphone className="w-4 h-4 text-amber-600" /> },
//     { label: "Distributor Name", value: merchantdetails?.others?.distributor_name, icon: <UserCheck className="w-4 h-4 text-purple-600" /> },
//     { label: "Distributor Mobile", value: merchantdetails?.others?.distributor_mobile, icon: <PhoneCall className="w-4 h-4 text-rose-600" /> },
//   ];

//   return (
//     <div className="min-h-screen bg-[#F8FAFC] p-4 sm:p-6 lg:p-8">
//       <div className="max-w-6xl mx-auto space-y-6">

//         {/* ================= HERO PROFILE BANNER ================= */}
//         <div className="relative overflow-hidden rounded-3xl bg-gradient-to-r from-[#0A2540] via-[#0F3057] to-[#123E6B] p-6 sm:p-8 text-white shadow-xl shadow-slate-900/5 border border-slate-800">
//           <div className="relative z-10 flex flex-col sm:flex-row items-center gap-5">
//             <div className="w-20 h-20 rounded-2xl bg-white/10 border border-white/20 flex items-center justify-center text-white backdrop-blur-md shadow-md text-3xl font-bold shrink-0">
//               {merchantdetails?.others?.merchant_shop_name 
//                 ? merchantdetails.others.merchant_shop_name.charAt(0).toUpperCase() 
//                 : <UserCircle2 className="w-10 h-10 text-sky-300" />}
//             </div>

//             <div className="text-center sm:text-left space-y-1">
//               <div className="flex flex-wrap items-center justify-center sm:justify-start gap-2.5">
//                 <h1 className="text-xl sm:text-2xl font-bold tracking-tight text-white">
//                   {merchantdetails?.others?.merchant_shop_name || "Merchant Profile"}
//                 </h1>
//                 <span className="px-2.5 py-0.5 rounded-full text-[11px] font-semibold bg-emerald-500/20 text-emerald-300 border border-emerald-400/30">
//                   {merchantdetails?.role || "MERCHANT"}
//                 </span>
//               </div>
//               <p className="text-xs text-blue-200/80 font-medium">
//                 Terminal ID: <span className="font-mono text-white">{merchantdetails?.userId || "—"}</span> • Mobile: <span className="font-mono text-white">{merchantdetails?.mobile_number || "—"}</span>
//               </p>
//             </div>
//           </div>
//         </div>

//         {/* ================= MAIN 2-COLUMN GRID ================= */}
//         <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">

//           {/* 1. PERSONAL INFORMATION (2 Columns on Large Screens) */}
//           <div className="lg:col-span-2 bg-white rounded-3xl p-6 border border-slate-200/80 shadow-xs space-y-5">
//             <div className="flex items-center gap-2.5 border-b border-slate-100 pb-4">
//               <div className="p-2 rounded-xl bg-blue-50 text-blue-600">
//                 <User className="w-4 h-4" />
//               </div>
//               <div>
//                 <h2 className="text-base font-bold text-slate-800">Account Details</h2>
//                 <p className="text-xs text-slate-400 font-medium">Personal and terminal identification parameters</p>
//               </div>
//             </div>

//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-3.5">
//               {infoList.map((item, idx) => (
//                 <div
//                   key={idx}
//                   className="flex items-start gap-3 p-3.5 rounded-2xl bg-slate-50/80 hover:bg-slate-50 border border-slate-200/60 transition-colors"
//                 >
//                   <div className="p-2 rounded-xl bg-white border border-slate-200/60 shadow-2xs shrink-0 mt-0.5">
//                     {item.icon}
//                   </div>
//                   <div className="min-w-0">
//                     <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-400">
//                       {item.label}
//                     </p>
//                     <p className="text-xs font-bold text-slate-800 truncate mt-0.5">
//                       {item.value || "N.A"}
//                     </p>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* 2. SECURITY CONTROLS (MPIN & PASSWORD) */}
//           <div className="bg-white rounded-3xl p-6 border border-slate-200/80 shadow-xs space-y-6">
//             <div className="flex items-center gap-2.5 border-b border-slate-100 pb-4">
//               <div className="p-2 rounded-xl bg-amber-50 text-amber-600">
//                 <ShieldCheck className="w-4 h-4" />
//               </div>
//               <div>
//                 <h2 className="text-base font-bold text-slate-800">Security & Access</h2>
//                 <p className="text-xs text-slate-400 font-medium">Manage authorization keys</p>
//               </div>
//             </div>

//             {/* SECTION A: MPIN UPDATE */}
//             <div className="space-y-3">
//               <div className="flex items-center justify-between">
//                 <label className="text-xs font-bold text-slate-700 uppercase tracking-wide flex items-center gap-1.5">
//                   <KeyRound className="w-3.5 h-3.5 text-blue-600" /> Transaction MPIN
//                 </label>
//                 {otpVerified && (
//                   <span className="text-[10px] font-semibold text-emerald-600 flex items-center gap-1">
//                     <CheckCircle2 className="w-3 h-3" /> OTP Verified
//                   </span>
//                 )}
//               </div>

//               {!otpSent ? (
//                 <button
//                   onClick={handleSendOtp}
//                   className="w-full py-2.5 px-4 rounded-xl text-xs font-semibold bg-slate-900 hover:bg-slate-800 text-white transition active:scale-98 flex items-center justify-center gap-2 shadow-xs"
//                 >
//                   <Send className="w-3.5 h-3.5" /> Send MPIN OTP
//                 </button>
//               ) : !otpVerified ? (
//                 <div className="space-y-2">
//                   <input
//                     value={mpinData.otp}
//                     onChange={(e) =>
//                       handleMpinChange("otp", e.target.value.replace(/\D/g, ""))
//                     }
//                     maxLength={6}
//                     placeholder="Enter 6-digit OTP"
//                     className="w-full px-3.5 py-2.5 bg-slate-50 border border-slate-200 focus:border-blue-500 rounded-xl text-xs text-slate-800 tracking-widest placeholder:tracking-normal outline-hidden"
//                   />

//                   <button
//                     onClick={handleVerifyOtp}
//                     className="w-full py-2.5 rounded-xl text-xs font-semibold bg-blue-600 hover:bg-blue-700 text-white transition active:scale-98"
//                   >
//                     Verify OTP
//                   </button>
//                 </div>
//               ) : (
//                 <div className="space-y-2">
//                   <input
//                     type="password"
//                     value={mpinData.newMpin}
//                     onChange={(e) =>
//                       handleMpinChange("newMpin", e.target.value.replace(/\D/g, ""))
//                     }
//                     maxLength={6}
//                     placeholder="New 6-Digit MPIN"
//                     className="w-full px-3.5 py-2.5 bg-slate-50 border border-slate-200 focus:border-blue-500 rounded-xl text-xs text-slate-800 outline-hidden"
//                   />
//                   <input
//                     type="password"
//                     value={mpinData.confirmMpin}
//                     onChange={(e) =>
//                       handleMpinChange("confirmMpin", e.target.value.replace(/\D/g, ""))
//                     }
//                     maxLength={6}
//                     placeholder="Confirm 6-Digit MPIN"
//                     className="w-full px-3.5 py-2.5 bg-slate-50 border border-slate-200 focus:border-blue-500 rounded-xl text-xs text-slate-800 outline-hidden"
//                   />
//                   <button
//                     onClick={handleSetMpin}
//                     className="w-full py-2.5 rounded-xl text-xs font-semibold bg-emerald-600 hover:bg-emerald-700 text-white transition active:scale-98 shadow-xs"
//                   >
//                     Save New MPIN
//                   </button>
//                 </div>
//               )}
//             </div>

//             {/* SECTION B: PASSWORD RESET */}
//             <div className="pt-4 border-t border-slate-100 space-y-3">
//               <label className="text-xs font-bold text-slate-700 uppercase tracking-wide flex items-center gap-1.5">
//                 <Lock className="w-3.5 h-3.5 text-indigo-600" /> Account Password
//               </label>

//               {!passwordOtpSent ? (
//                 <button
//                   onClick={handleSendPasswordOtp}
//                   className="w-full py-2.5 px-4 rounded-xl text-xs font-semibold border border-slate-200 hover:bg-slate-50 text-slate-700 transition active:scale-98 flex items-center justify-center gap-2"
//                 >
//                   <Key className="w-3.5 h-3.5" /> Request Password OTP
//                 </button>
//               ) : (
//                 <div className="space-y-2">
//                   <input
//                     value={passwordData.otp}
//                     onChange={(e) =>
//                       setPasswordData((prev) => ({
//                         ...prev,
//                         otp: e.target.value.replace(/\D/g, ""),
//                       }))
//                     }
//                     maxLength={6}
//                     placeholder="Enter 6-digit OTP"
//                     className="w-full px-3.5 py-2.5 bg-slate-50 border border-slate-200 focus:border-blue-500 rounded-xl text-xs text-slate-800 tracking-widest placeholder:tracking-normal outline-hidden"
//                   />

//                   <input
//                     type="password"
//                     value={passwordData.newPassword}
//                     onChange={(e) =>
//                       setPasswordData((prev) => ({
//                         ...prev,
//                         newPassword: e.target.value,
//                       }))
//                     }
//                     placeholder="New Password"
//                     className="w-full px-3.5 py-2.5 bg-slate-50 border border-slate-200 focus:border-blue-500 rounded-xl text-xs text-slate-800 outline-hidden"
//                   />

//                   <input
//                     type="password"
//                     value={passwordData.confirmPassword}
//                     onChange={(e) =>
//                       setPasswordData((prev) => ({
//                         ...prev,
//                         confirmPassword: e.target.value,
//                       }))
//                     }
//                     placeholder="Confirm New Password"
//                     className="w-full px-3.5 py-2.5 bg-slate-50 border border-slate-200 focus:border-blue-500 rounded-xl text-xs text-slate-800 outline-hidden"
//                   />

//                   <button
//                     onClick={handleResetPassword}
//                     className="w-full py-2.5 rounded-xl text-xs font-semibold bg-indigo-600 hover:bg-indigo-700 text-white transition active:scale-98 shadow-xs"
//                   >
//                     Update Password
//                   </button>
//                 </div>
//               )}
//             </div>

//           </div>

//         </div>
//       </div>

//       {/* ================= MODERN MODAL NOTIFICATION ================= */}
//       {showPopup && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/60 backdrop-blur-xs p-4 animate-in fade-in duration-150">
//           <div className="bg-white rounded-3xl shadow-2xl w-full max-w-sm p-6 border border-slate-100 text-center space-y-4">
//             <div className="flex justify-center">
//               {popupData.type === "success" ? (
//                 <div className="w-12 h-12 flex items-center justify-center rounded-2xl bg-emerald-50 text-emerald-600 border border-emerald-100">
//                   <CheckCircle2 className="w-6 h-6" />
//                 </div>
//               ) : (
//                 <div className="w-12 h-12 flex items-center justify-center rounded-full bg-rose-50 text-rose-600 border border-rose-100">
//                   <AlertCircle className="w-6 h-6" />
//                 </div>
//               )}
//             </div>

//             <div className="space-y-1">
//               <h3 className="text-base font-bold text-slate-800">
//                 {popupData.type === "success" ? "Operation Successful" : "Notification"}
//               </h3>
//               <p className="text-xs text-slate-600 leading-relaxed">
//                 {popupData.text}
//               </p>
//             </div>

//             <button
//               onClick={() => setShowPopup(false)}
//               className="w-full py-2.5 rounded-xl font-semibold text-xs text-white bg-slate-900 hover:bg-slate-800 transition active:scale-98 shadow-sm"
//             >
//               Acknowledge
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Profile;



import React, { useState, useEffect } from "react";
import {
  UserCircle2,
  ShieldCheck,
  KeyRound,
  Lock,
  Smartphone,
  Store,
  User,
  Hash,
  CheckCircle2,
  AlertCircle,
  Key,
  CreditCard,
  PhoneCall,
  UserCheck,
  Percent,
} from "lucide-react";
import { useSelector } from "react-redux";
import useApi from "../CustomHooks/useApi";

const Profile = () => {
  const merchantdetails = useSelector((state) => state.auth?.employeeDetails);

  // ---------------- MPIN state ----------------
  const [mpinData, setMpinData] = useState({
    mobileNumber: "",
    otp: "",
    newMpin: "",
    confirmMpin: "",
  });
  const [mpinOtpRequired, setMpinOtpRequired] = useState(false);
  const [mpinOtp, setMpinOtp] = useState("");
  const [mpinOtpSentTo, setMpinOtpSentTo] = useState("");
  const [mpinPendingPayload, setMpinPendingPayload] = useState(null);
  const [mpinLoading, setMpinLoading] = useState(false);

  // ---------------- Password state ----------------
  const [passwordData, setPasswordData] = useState({
    otp: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [passwordOtpRequired, setPasswordOtpRequired] = useState(false);
  const [passwordOtp, setPasswordOtp] = useState("");
  const [passwordOtpSentTo, setPasswordOtpSentTo] = useState("");
  const [passwordPendingPayload, setPasswordPendingPayload] = useState(null);
  const [passwordLoading, setPasswordLoading] = useState(false);

  // ---------------- Wallet transfer state ----------------
  const [transferAmount, setTransferAmount] = useState("");
  const [transferMessage, setTransferMessage] = useState({
    type: "",
    text: "",
  });
  const [isloading, setIsLoading] = useState(false);

  const [transferAepsAmount, setTransferAepsAmount] = useState("");
  const [transferAepsMessage, setTransferAepsMessage] = useState({
    type: "",
    text: "",
  });
  const [isloadingAeps, setIsLoadingAeps] = useState(false);

  // ---------------- Popup ----------------
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState({ type: "", text: "" });

  // ---------------- Markup state ----------------
  const [showMarkupModal, setShowMarkupModal] = useState(false);
  const [markupType, setMarkupType] = useState("PERCENTAGE");
  const [markupValue, setMarkupValue] = useState("");
  const [initialMarkup, setInitialMarkup] = useState({
    type: "PERCENTAGE",
    value: "",
  });
  const [isMarkupLoading, setIsMarkupLoading] = useState(false);

  // ---------------- APIs ----------------
  const { callApi: getMarkupApi } = useApi("/user/markup/air", "GET");
  const { callApi: updateMarkupApi } = useApi("/user/markup/air", "PUT");
  const { callApi: resetMpinApi } = useApi(
    "/staff/onboard/forget/password",
    "POST",
    false
  );

  const { callApi: transferCommissionApi } = useApi(
    "/business/wallet/settle",
    "POST"
  );
  const { callApi: transferaepstomainwallet } = useApi(
    "/business/wallet/aeps/settle",
    "POST"
  );

  // =============================================================
  // MARKUP LOGIC
  // =============================================================
  const fetchAirMarkup = async () => {
    const username = merchantdetails?.username || merchantdetails?.userId;
    if (!username) return;

    try {
      const res = await getMarkupApi(null, `?username=${username}`);
      if (res?.value !== undefined) {
        const fetchedType = res.type || "PERCENTAGE";
        const fetchedVal = String(res.value);
        setMarkupType(fetchedType);
        setMarkupValue(fetchedVal);
        setInitialMarkup({ type: fetchedType, value: fetchedVal });
      }
    } catch (err) {
      console.error("Error fetching markup:", err);
    }
  };

  useEffect(() => {
    fetchAirMarkup();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantdetails]);

  const handleUpdateMarkup = async () => {
    if (markupValue === "" || isNaN(Number(markupValue))) {
      setPopupData({
        type: "error",
        text: "Please enter a valid numeric markup value.",
      });
      setShowPopup(true);
      return;
    }

    const username = merchantdetails?.username || merchantdetails?.userId;
    setIsMarkupLoading(true);

    try {
      const body = {
        type: markupType,
        value: Number(markupValue),
      };

      const res = await updateMarkupApi(body, `?username=${username}`);

      if (res?.value !== undefined) {
        const updatedType = res.type || markupType;
        const updatedVal = String(res.value);
        setMarkupType(updatedType);
        setMarkupValue(updatedVal);
        setInitialMarkup({ type: updatedType, value: updatedVal });

        setShowMarkupModal(false);
        setPopupData({
          type: "success",
          text: "Air markup updated successfully.",
        });
        setShowPopup(true);
      } else {
        setPopupData({
          type: "error",
          text: res?.message || "Failed to update markup.",
        });
        setShowPopup(true);
      }
    } catch (err) {
      setPopupData({
        type: "error",
        text: err?.message || "Server error updating markup.",
      });
      setShowPopup(true);
    } finally {
      setIsMarkupLoading(false);
    }
  };

  const isSameValue =
    markupValue !== "" &&
    markupType === initialMarkup.type &&
    Number(markupValue) === Number(initialMarkup.value);

  // =============================================================
  // MOBILE NUMBER SYNC
  // =============================================================
  useEffect(() => {
    if (merchantdetails?.mobile_number) {
      setMpinData((prev) => ({
        ...prev,
        mobileNumber: merchantdetails.mobile_number,
      }));
    }
  }, [merchantdetails]);

  // =============================================================
  // MPIN UPDATE (new OTP flow)
  // =============================================================
  const handleMpinChange = (field, value) => {
    setMpinData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSetMpin = async () => {
    if (mpinData.newMpin !== mpinData.confirmMpin) {
      setPopupData({
        type: "error",
        text: "MPIN and Confirm MPIN do not match!",
      });
      setShowPopup(true);
      return;
    }
    if (mpinData.newMpin.length !== 6) {
      setPopupData({ type: "error", text: "MPIN must be 6 digits!" });
      setShowPopup(true);
      return;
    }

    const body = {
      mobile_number: mpinData.mobileNumber,
      mpin: mpinData.newMpin,
      confirm_mpin: mpinData.confirmMpin,
    };

    setMpinLoading(true);
    try {
      const response = await resetMpinApi(body);

      if (
        response?.status === "VERIFIED" ||
        response?.status === "SUCCESS"
      ) {
        setPopupData({
          type: "success",
          text: response.message || "MPIN updated successfully",
        });
        setShowPopup(true);

        setMpinData({
          mobileNumber: merchantdetails?.mobile_number || "",
          otp: "",
          newMpin: "",
          confirmMpin: "",
        });
      } else {
        setPopupData({
          type: "error",
          text: response.message || "Failed to update MPIN",
        });
        setShowPopup(true);
      }
    } catch (error) {
      if (
        error?.response?.status === 400 &&
        error?.response?.data?.error_code === "OTP_REQUIRED"
      ) {
        setMpinPendingPayload(body);
        setMpinOtpSentTo(error?.response?.data?.action_params?.sentTo || "");
        setMpinOtp("");
        setMpinOtpRequired(true);
      } else {
        setPopupData({
          type: "error",
          text:
            error?.response?.data?.message ||
            "Something went wrong while updating MPIN",
        });
        setShowPopup(true);
      }
    } finally {
      setMpinLoading(false);
    }
  };

  const handleMpinOtpSubmit = async () => {
    if (!/^\d{6}$/.test(mpinOtp)) {
      setPopupData({ type: "error", text: "Enter valid 6-digit OTP" });
      setShowPopup(true);
      return;
    }

    setMpinLoading(true);
    try {
      const response = await resetMpinApi({
        ...mpinPendingPayload,
        otp: mpinOtp,
      });

      if (
        response?.status === "VERIFIED" ||
        response?.status === "SUCCESS"
      ) {
        setPopupData({
          type: "success",
          text: response.message || "MPIN updated successfully",
        });
        setShowPopup(true);

        setMpinData({
          mobileNumber: merchantdetails?.mobile_number || "",
          otp: "",
          newMpin: "",
          confirmMpin: "",
        });

        setMpinOtpRequired(false);
        setMpinPendingPayload(null);
        setMpinOtpSentTo("");
        setMpinOtp("");
      } else {
        setPopupData({
          type: "error",
          text: response.message || "Failed to update MPIN",
        });
        setShowPopup(true);
      }
    } catch (error) {
      setPopupData({
        type: "error",
        text:
          error?.response?.data?.message ||
          "OTP verification failed. Please try again.",
      });
      setShowPopup(true);
    } finally {
      setMpinLoading(false);
    }
  };

  // =============================================================
  // PASSWORD RESET (new OTP flow)
  // =============================================================
  const handleResetPassword = async () => {
    const { newPassword, confirmPassword } = passwordData;

    if (!newPassword || !confirmPassword) {
      setPopupData({
        type: "error",
        text: "Please fill both password fields",
      });
      setShowPopup(true);
      return;
    }

    if (newPassword !== confirmPassword) {
      setPopupData({ type: "error", text: "Passwords do not match" });
      setShowPopup(true);
      return;
    }

    const body = {
      mobile_number: merchantdetails?.mobile_number,
      password: newPassword,
      confirm_password: confirmPassword,
    };

    setPasswordLoading(true);
    try {
      const response = await resetMpinApi(body);

      if (
        response?.status === "SUCCESS" ||
        response?.status === "VERIFIED"
      ) {
        setPopupData({
          type: "success",
          text: response.message || "Password updated successfully",
        });
        setShowPopup(true);

        setPasswordData({
          otp: "",
          newPassword: "",
          confirmPassword: "",
        });
      } else {
        setPopupData({
          type: "error",
          text: response.message || "Failed to reset password",
        });
        setShowPopup(true);
      }
    } catch (error) {
      if (
        error?.response?.status === 400 &&
        error?.response?.data?.error_code === "OTP_REQUIRED"
      ) {
        setPasswordPendingPayload(body);
        setPasswordOtpSentTo(
          error?.response?.data?.action_params?.sentTo || ""
        );
        setPasswordOtp("");
        setPasswordOtpRequired(true);
      } else {
        setPopupData({
          type: "error",
          text:
            error?.response?.data?.message ||
            "Server error while resetting password",
        });
        setShowPopup(true);
      }
    } finally {
      setPasswordLoading(false);
    }
  };

  const handlePasswordOtpSubmit = async () => {
    if (!/^\d{6}$/.test(passwordOtp)) {
      setPopupData({ type: "error", text: "Enter valid 6-digit OTP" });
      setShowPopup(true);
      return;
    }

    setPasswordLoading(true);
    try {
      const response = await resetMpinApi({
        ...passwordPendingPayload,
        otp: passwordOtp,
      });

      if (
        response?.status === "SUCCESS" ||
        response?.status === "VERIFIED"
      ) {
        setPopupData({
          type: "success",
          text: response.message || "Password updated successfully",
        });
        setShowPopup(true);

        setPasswordData({
          otp: "",
          newPassword: "",
          confirmPassword: "",
        });

        setPasswordOtpRequired(false);
        setPasswordPendingPayload(null);
        setPasswordOtpSentTo("");
        setPasswordOtp("");
      } else {
        setPopupData({
          type: "error",
          text: response.message || "Failed to reset password",
        });
        setShowPopup(true);
      }
    } catch (error) {
      setPopupData({
        type: "error",
        text:
          error?.response?.data?.message ||
          "OTP verification failed. Please try again.",
      });
      setShowPopup(true);
    } finally {
      setPasswordLoading(false);
    }
  };

  // =============================================================
  // ROLE-BASED INFO
  // =============================================================
  const getRoleBasedInfo = () => {
    const baseInfo = [
      {
        label: "User ID",
        value: merchantdetails?.userId,
        icon: <Hash className="w-4 h-4 text-blue-600" />,
      },
      {
        label: "Shop Name",
        value: merchantdetails?.others?.merchant_shop_name,
        icon: <Store className="w-4 h-4 text-indigo-600" />,
      },
      {
        label: "Account Role",
        value: merchantdetails?.role,
        icon: <User className="w-4 h-4 text-sky-600" />,
      },
      {
        label: "Merchant Account No",
        value: merchantdetails?.merchant_account_no,
        icon: <CreditCard className="w-4 h-4 text-emerald-600" />,
      },
      {
        label: "Registered Mobile",
        value: merchantdetails?.mobile_number,
        icon: <Smartphone className="w-4 h-4 text-amber-600" />,
      },
    ];

    if (merchantdetails?.role === "DISTRIBUTOR") {
      baseInfo.push(
        {
          label: "Master Distributor Name",
          value: merchantdetails?.others?.master_distributor_name,
          icon: <UserCheck className="w-4 h-4 text-purple-600" />,
        },
        {
          label: "Master Distributor Mobile",
          value: merchantdetails?.others?.master_distributor_mobile,
          icon: <PhoneCall className="w-4 h-4 text-rose-600" />,
        }
      );
    } else if (merchantdetails?.role === "MASTER_DISTRIBUTOR") {
      baseInfo.push(
        {
          label: "Sales Person Name",
          value: merchantdetails?.others?.sales_guy_name,
          icon: <UserCheck className="w-4 h-4 text-purple-600" />,
        },
        {
          label: "Sales Person Mobile",
          value: merchantdetails?.others?.sales_guy_mobile,
          icon: <PhoneCall className="w-4 h-4 text-rose-600" />,
        }
      );
    } else {
      baseInfo.push(
        {
          label: "Distributor Name",
          value: merchantdetails?.others?.distributor_name,
          icon: <UserCheck className="w-4 h-4 text-purple-600" />,
        },
        {
          label: "Distributor Mobile",
          value: merchantdetails?.others?.distributor_mobile,
          icon: <PhoneCall className="w-4 h-4 text-rose-600" />,
        }
      );
    }

    return baseInfo;
  };

  const infoList = getRoleBasedInfo();

  // =============================================================
  // RENDER
  // =============================================================
  return (
    <div className="min-h-screen bg-[#F8FAFC] p-4 sm:p-6 lg:p-8">
      <div className="max-w-6xl mx-auto space-y-6">
        {/* ================= HERO PROFILE BANNER ================= */}
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-r from-[#0A2540] via-[#0F3057] to-[#123E6B] p-6 sm:p-8 text-white shadow-xl shadow-slate-900/5 border border-slate-800">
          <div className="relative z-10 flex flex-col sm:flex-row items-center gap-5">
            <div className="w-20 h-20 rounded-2xl bg-white/10 border border-white/20 flex items-center justify-center text-white backdrop-blur-md shadow-md text-3xl font-bold shrink-0">
              {merchantdetails?.others?.merchant_shop_name ? (
                merchantdetails.others.merchant_shop_name
                  .charAt(0)
                  .toUpperCase()
              ) : (
                <UserCircle2 className="w-10 h-10 text-sky-300" />
              )}
            </div>

            <div className="text-center sm:text-left space-y-1">
              <div className="flex flex-wrap items-center justify-center sm:justify-start gap-2.5">
                <h1 className="text-xl sm:text-2xl font-bold tracking-tight text-white">
                  {merchantdetails?.others?.merchant_shop_name ||
                    "Merchant Profile"}
                </h1>
                <span className="px-2.5 py-0.5 rounded-full text-[11px] font-semibold bg-emerald-500/20 text-emerald-300 border border-emerald-400/30">
                  {merchantdetails?.role || "MERCHANT"}
                </span>
              </div>
              <p className="text-xs text-blue-200/80 font-medium">
                Terminal ID:{" "}
                <span className="font-mono text-white">
                  {merchantdetails?.userId || "—"}
                </span>{" "}
                • Mobile:{" "}
                <span className="font-mono text-white">
                  {merchantdetails?.mobile_number || "—"}
                </span>
              </p>
            </div>
          </div>
        </div>

        {/* ================= MAIN 2-COLUMN GRID ================= */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* 1. PERSONAL INFORMATION */}
          <div className="lg:col-span-2 bg-white rounded-3xl p-6 border border-slate-200/80 shadow-xs space-y-5">
            <div className="flex items-center gap-2.5 border-b border-slate-100 pb-4">
              <div className="p-2 rounded-xl bg-blue-50 text-blue-600">
                <User className="w-4 h-4" />
              </div>
              <div>
                <h2 className="text-base font-bold text-slate-800">
                  Account Details
                </h2>
                <p className="text-xs text-slate-400 font-medium">
                  Personal and terminal identification parameters
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3.5">
              {infoList.map((item, idx) => (
                <div
                  key={idx}
                  className="flex items-start gap-3 p-3.5 rounded-2xl bg-slate-50/80 hover:bg-slate-50 border border-slate-200/60 transition-colors"
                >
                  <div className="p-2 rounded-xl bg-white border border-slate-200/60 shadow-2xs shrink-0 mt-0.5">
                    {item.icon}
                  </div>
                  <div className="min-w-0">
                    <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-400">
                      {item.label}
                    </p>
                    <p className="text-xs font-bold text-slate-800 truncate mt-0.5">
                      {item.value || "N.A"}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* 2. SECURITY CONTROLS */}
          <div className="bg-white rounded-3xl p-6 border border-slate-200/80 shadow-xs space-y-6">
            <div className="flex items-center gap-2.5 border-b border-slate-100 pb-4">
              <div className="p-2 rounded-xl bg-amber-50 text-amber-600">
                <ShieldCheck className="w-4 h-4" />
              </div>
              <div>
                <h2 className="text-base font-bold text-slate-800">
                  Security & Access
                </h2>
                <p className="text-xs text-slate-400 font-medium">
                  Manage authorization keys
                </p>
              </div>
            </div>

            {/* ============ SECTION A: MPIN UPDATE ============ */}
            <div className="space-y-3">
              <div className="flex items-center justify-between">
                <label className="text-xs font-bold text-slate-700 uppercase tracking-wide flex items-center gap-1.5">
                  <KeyRound className="w-3.5 h-3.5 text-blue-600" /> Transaction
                  MPIN
                </label>
                {mpinOtpRequired && (
                  <span className="text-[10px] font-semibold text-amber-600 flex items-center gap-1">
                    <AlertCircle className="w-3 h-3" /> OTP Required
                  </span>
                )}
              </div>

              {!mpinOtpRequired ? (
                <div className="space-y-2">
                  <input
                    type="password"
                    inputMode="numeric"
                    value={mpinData.newMpin}
                    onChange={(e) =>
                      handleMpinChange(
                        "newMpin",
                        e.target.value.replace(/\D/g, "")
                      )
                    }
                    maxLength={6}
                    placeholder="New 6-Digit MPIN"
                    className="w-full px-3.5 py-2.5 bg-slate-50 border border-slate-200 focus:border-blue-500 rounded-xl text-xs text-slate-800 outline-hidden"
                  />
                  <input
                    type="password"
                    inputMode="numeric"
                    value={mpinData.confirmMpin}
                    onChange={(e) =>
                      handleMpinChange(
                        "confirmMpin",
                        e.target.value.replace(/\D/g, "")
                      )
                    }
                    maxLength={6}
                    placeholder="Confirm 6-Digit MPIN"
                    className="w-full px-3.5 py-2.5 bg-slate-50 border border-slate-200 focus:border-blue-500 rounded-xl text-xs text-slate-800 outline-hidden"
                  />
                  <button
                    onClick={handleSetMpin}
                    disabled={
                      mpinLoading ||
                      mpinData.newMpin.length !== 6 ||
                      mpinData.confirmMpin.length !== 6
                    }
                    className={`w-full py-2.5 rounded-xl text-xs font-semibold text-white transition active:scale-98 shadow-xs ${
                      mpinLoading ||
                      mpinData.newMpin.length !== 6 ||
                      mpinData.confirmMpin.length !== 6
                        ? "bg-slate-300 cursor-not-allowed text-slate-500"
                        : "bg-emerald-600 hover:bg-emerald-700"
                    }`}
                  >
                    {mpinLoading ? "Processing..." : "Save New MPIN"}
                  </button>
                </div>
              ) : (
                <div className="space-y-2">
                  {mpinOtpSentTo && (
                    <p className="text-[11px] text-slate-500">
                      OTP sent to{" "}
                      <span className="font-semibold text-slate-800">
                        {mpinOtpSentTo}
                      </span>
                    </p>
                  )}

                  <input
                    value={mpinOtp}
                    onChange={(e) =>
                      setMpinOtp(e.target.value.replace(/\D/g, ""))
                    }
                    maxLength={6}
                    inputMode="numeric"
                    placeholder="Enter 6-digit OTP"
                    className="w-full px-3.5 py-2.5 bg-slate-50 border border-slate-200 focus:border-blue-500 rounded-xl text-xs text-slate-800 tracking-widest placeholder:tracking-normal outline-hidden"
                  />

                  <button
                    onClick={handleMpinOtpSubmit}
                    disabled={mpinLoading || mpinOtp.length !== 6}
                    className={`w-full py-2.5 rounded-xl text-xs font-semibold text-white transition active:scale-98 ${
                      mpinLoading || mpinOtp.length !== 6
                        ? "bg-slate-300 cursor-not-allowed text-slate-500"
                        : "bg-blue-600 hover:bg-blue-700"
                    }`}
                  >
                    {mpinLoading ? "Verifying..." : "Verify & Save MPIN"}
                  </button>

                  <button
                    type="button"
                    onClick={() => {
                      setMpinOtpRequired(false);
                      setMpinPendingPayload(null);
                      setMpinOtp("");
                      setMpinOtpSentTo("");
                    }}
                    className="w-full py-2 rounded-xl text-[11px] font-semibold text-slate-500 bg-slate-100 hover:bg-slate-200 transition"
                  >
                    Cancel
                  </button>
                </div>
              )}
            </div>

            {/* ============ SECTION B: PASSWORD RESET ============ */}
            <div className="pt-4 border-t border-slate-100 space-y-3">
              <label className="text-xs font-bold text-slate-700 uppercase tracking-wide flex items-center gap-1.5">
                <Lock className="w-3.5 h-3.5 text-indigo-600" /> Account
                Password
              </label>

              {!passwordOtpRequired ? (
                <div className="space-y-2">
                  <input
                    type="password"
                    value={passwordData.newPassword}
                    onChange={(e) =>
                      setPasswordData((prev) => ({
                        ...prev,
                        newPassword: e.target.value,
                      }))
                    }
                    placeholder="New Password"
                    className="w-full px-3.5 py-2.5 bg-slate-50 border border-slate-200 focus:border-blue-500 rounded-xl text-xs text-slate-800 outline-hidden"
                  />
                  <input
                    type="password"
                    value={passwordData.confirmPassword}
                    onChange={(e) =>
                      setPasswordData((prev) => ({
                        ...prev,
                        confirmPassword: e.target.value,
                      }))
                    }
                    placeholder="Confirm New Password"
                    className="w-full px-3.5 py-2.5 bg-slate-50 border border-slate-200 focus:border-blue-500 rounded-xl text-xs text-slate-800 outline-hidden"
                  />
                  <button
                    onClick={handleResetPassword}
                    disabled={
                      passwordLoading ||
                      !passwordData.newPassword ||
                      !passwordData.confirmPassword
                    }
                    className={`w-full py-2.5 rounded-xl text-xs font-semibold text-white transition active:scale-98 shadow-xs ${
                      passwordLoading ||
                      !passwordData.newPassword ||
                      !passwordData.confirmPassword
                        ? "bg-slate-300 cursor-not-allowed text-slate-500"
                        : "bg-indigo-600 hover:bg-indigo-700"
                    }`}
                  >
                    {passwordLoading ? "Processing..." : "Update Password"}
                  </button>
                </div>
              ) : (
                <div className="space-y-2">
                  {passwordOtpSentTo && (
                    <p className="text-[11px] text-slate-500">
                      OTP sent to{" "}
                      <span className="font-semibold text-slate-800">
                        {passwordOtpSentTo}
                      </span>
                    </p>
                  )}

                  <input
                    value={passwordOtp}
                    onChange={(e) =>
                      setPasswordOtp(e.target.value.replace(/\D/g, ""))
                    }
                    maxLength={6}
                    inputMode="numeric"
                    placeholder="Enter 6-digit OTP"
                    className="w-full px-3.5 py-2.5 bg-slate-50 border border-slate-200 focus:border-blue-500 rounded-xl text-xs text-slate-800 tracking-widest placeholder:tracking-normal outline-hidden"
                  />

                  <button
                    onClick={handlePasswordOtpSubmit}
                    disabled={passwordLoading || passwordOtp.length !== 6}
                    className={`w-full py-2.5 rounded-xl text-xs font-semibold text-white transition active:scale-98 ${
                      passwordLoading || passwordOtp.length !== 6
                        ? "bg-slate-300 cursor-not-allowed text-slate-500"
                        : "bg-indigo-600 hover:bg-indigo-700"
                    }`}
                  >
                    {passwordLoading
                      ? "Verifying..."
                      : "Verify & Update Password"}
                  </button>

                  <button
                    type="button"
                    onClick={() => {
                      setPasswordOtpRequired(false);
                      setPasswordPendingPayload(null);
                      setPasswordOtp("");
                      setPasswordOtpSentTo("");
                    }}
                    className="w-full py-2 rounded-xl text-[11px] font-semibold text-slate-500 bg-slate-100 hover:bg-slate-200 transition"
                  >
                    Cancel
                  </button>
                </div>
              )}
            </div>

            {/* ============ SECTION C: AIR TICKET MARKUP ============ */}
            <div className="pt-4 border-t border-slate-100 space-y-2">
              <label className="text-xs font-bold text-slate-700 uppercase tracking-wide flex items-center gap-1.5">
                <Percent className="w-3.5 h-3.5 text-sky-600" /> Commercial
                Markup
              </label>

              <button
                onClick={() => {
                  fetchAirMarkup();
                  setShowMarkupModal(true);
                }}
                className="w-full py-2.5 px-4 rounded-xl text-xs font-semibold bg-sky-50 hover:bg-sky-100/80 border border-sky-200 text-sky-700 transition active:scale-98 flex items-center justify-between shadow-2xs"
              >
                <span className="flex items-center gap-2">
                  <Percent className="w-3.5 h-3.5 text-sky-600" /> Air Ticket
                  Markup
                </span>
                <span className="text-[11px] font-bold bg-white px-2 py-0.5 rounded-md border border-sky-100 text-sky-800">
                  {initialMarkup.value !== ""
                    ? `${initialMarkup.value} ${
                        initialMarkup.type === "PERCENTAGE" ? "%" : "₹"
                      }`
                    : "Configure"}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ================= AIR MARKUP MODAL ================= */}
      {showMarkupModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/60 backdrop-blur-xs p-4 animate-in fade-in duration-150">
          <div className="bg-white rounded-3xl shadow-2xl w-full max-w-md p-6 border border-slate-100 space-y-5">
            <div className="flex items-center justify-between border-b border-slate-100 pb-3">
              <div className="flex items-center gap-2.5">
                <div className="p-2 rounded-xl bg-sky-50 text-sky-600 border border-sky-100">
                  <Percent className="w-4 h-4" />
                </div>
                <div>
                  <h3 className="text-sm font-bold text-slate-800">
                    Air Ticket Markup
                  </h3>
                  <p className="text-[11px] text-slate-400 font-medium">
                    Configure customer fare adjustment
                  </p>
                </div>
              </div>
              <button
                onClick={() => setShowMarkupModal(false)}
                className="p-1.5 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition text-lg leading-none"
              >
                ×
              </button>
            </div>

            <div className="p-3.5 rounded-2xl bg-slate-50 border border-slate-200/70 flex items-center justify-between">
              <div>
                <span className="text-[10px] font-bold uppercase tracking-wider text-slate-400 block">
                  Current Markup
                </span>
                <span className="text-xs font-semibold text-slate-600">
                  Active billing parameter
                </span>
              </div>
              <div className="text-right">
                <span className="text-sm font-extrabold text-slate-800">
                  {initialMarkup.value !== ""
                    ? `${initialMarkup.value} ${
                        initialMarkup.type === "PERCENTAGE" ? "%" : "₹"
                      }`
                    : "Not Configured"}
                </span>
                <span className="block text-[10px] font-medium text-slate-400 uppercase">
                  {initialMarkup.type || "PERCENTAGE"}
                </span>
              </div>
            </div>

            <div className="space-y-3">
              <label className="text-xs font-bold text-slate-700 uppercase tracking-wide">
                Set New Markup
              </label>

              <div className="flex gap-2">
                <select
                  value={markupType}
                  onChange={(e) => setMarkupType(e.target.value)}
                  className="w-2/5 px-3 py-2.5 bg-slate-50 border border-slate-200 focus:border-sky-500 rounded-xl text-xs text-slate-800 outline-hidden font-medium"
                >
                  <option value="PERCENTAGE">PERCENT (%)</option>
                  <option value="FLAT">FLAT (₹)</option>
                </select>

                <input
                  type="number"
                  step="any"
                  value={markupValue}
                  onChange={(e) => setMarkupValue(e.target.value)}
                  placeholder="Enter value"
                  className="flex-1 px-3.5 py-2.5 bg-slate-50 border border-slate-200 focus:border-sky-500 rounded-xl text-xs text-slate-800 outline-hidden font-medium"
                />
              </div>

              {isSameValue && (
                <p className="text-[11px] font-semibold text-amber-600 bg-amber-50 border border-amber-200 px-3 py-1.5 rounded-lg">
                  New value cannot be the same as the current markup.
                </p>
              )}
            </div>

            <div className="flex gap-2 pt-2">
              <button
                type="button"
                onClick={() => setShowMarkupModal(false)}
                className="flex-1 py-2.5 rounded-xl font-semibold text-xs text-slate-600 bg-slate-100 hover:bg-slate-200 transition active:scale-98"
              >
                Cancel
              </button>

              <button
                type="button"
                onClick={handleUpdateMarkup}
                disabled={isSameValue || isMarkupLoading || markupValue === ""}
                className={`flex-1 py-2.5 rounded-xl font-semibold text-xs text-white transition active:scale-98 shadow-sm ${
                  isSameValue || isMarkupLoading || markupValue === ""
                    ? "bg-slate-300 cursor-not-allowed text-slate-500 shadow-none"
                    : "bg-sky-600 hover:bg-sky-700"
                }`}
              >
                {isMarkupLoading ? "Saving..." : "Save Markup"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ================= MODAL NOTIFICATION ================= */}
      {showPopup && (
        <div className="fixed inset-0 z-[999] flex items-center justify-center bg-slate-950/60 backdrop-blur-xs p-4 animate-in fade-in duration-150">
          <div className="bg-white rounded-3xl shadow-2xl w-full max-w-sm p-6 border border-slate-100 text-center space-y-4">
            <div className="flex justify-center">
              {popupData.type === "success" ? (
                <div className="w-12 h-12 flex items-center justify-center rounded-2xl bg-emerald-50 text-emerald-600 border border-emerald-100">
                  <CheckCircle2 className="w-6 h-6" />
                </div>
              ) : (
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-rose-50 text-rose-600 border border-rose-100">
                  <AlertCircle className="w-6 h-6" />
                </div>
              )}
            </div>

            <div className="space-y-1">
              <h3 className="text-base font-bold text-slate-800">
                {popupData.type === "success"
                  ? "Operation Successful"
                  : "Notification"}
              </h3>
              <p className="text-xs text-slate-600 leading-relaxed">
                {popupData.text}
              </p>
            </div>

            <button
              onClick={() => setShowPopup(false)}
              className="w-full py-2.5 rounded-xl font-semibold text-xs text-white bg-slate-900 hover:bg-slate-800 transition active:scale-98 shadow-sm"
            >
              Okay
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Profile;